import { Component, OnInit } from '@angular/core';
import { ReportTableService } from '../../service/table/report-table-service';
import { ReportService } from '../../service/table/report.service';
import { ReportTableComponent } from '../../components/table/report-table/report-table.component';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  standalone: true,
  imports: [ReportTableComponent],
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  reportService: ReportService;

  constructor(private service: ReportService) {
    this.reportService = service;
  }

  ngOnInit() {
  }

}
